'use strict';

module.exports = {
  STRING: 'string',
  ARRAY: 'array',
  ARRAY_MULTIPLE: 'array_multiple',
  ARRAY_INDEX: 'array_index',
  ARRAY_EQUAL: 'array_equal',
  OBJECT: 'object',
  ALL: 'all'
};